import React from 'react';
import HousesList from './pages/HouseList';

const App: React.FC = () => {
    return <HousesList />;
};

export default App;
